import type { EditorContainer } from '../interfaces';

/**
 * Test if a DOM node (HTMLElement or Text) is in a specific editor.
 */
export function isElementInEditor(editor: EditorContainer, node: Node): boolean {
    const documentKey = editor.value.document.key;

    if (node instanceof HTMLElement) {
        const editorAncestor = node.closest('[data-slate-editor]');
        if (editorAncestor) {
            return editorAncestor.getAttribute('data-document-key') === documentKey;
        }
    } else {
        if (node.parentNode) {
            return isElementInEditor(editor, node.parentNode);
        }
    }

    return false;
}
